module.exports = __webpack_public_path__ + "img/MenuManagement.e941e583.svg";